/* eslint-disable no-dupe-keys */
export default {
  // 登录相关
  loginValidateTicket: 'agent/bz/login/validate-ticket',
  logout: 'agent/bz/logout',
  loginUserInfo: 'agent/bz/login/user-info', // 获取已登录用户的详细信息
  getAllPermissions: 'role-permission/role/get-all', // 获取全量权限列表
  getRoleList: 'agent/bz/qnbar-agent/role/list', // 获取角色列表
  getRoleDetail: 'agent/bz/qnbar-agent/role/info', // 获取角色详情
  addRole: 'agent/bz/qnbar-agent/role/add', // 新增角色
  editRole: 'agent/bz/qnbar-agent/role/edit', // 编辑角色
  deleteRole: 'agent/bz/qnbar-agent/role/delete', // 删除角色
  getTreeRolePermission: 'agent/bz/qnbar-agent/role/all/permission', // 获取权限的树形结构
  addPermission: 'agent/bz/permission/create', // 创建权限
  editPermission: 'agent/bz/permission/update', // 编辑权限
  deletePermission: 'agent/bz/permission/del', // 删除权限
  getStaffList: 'agent/bz/qnbar-agent/role/user/list', // 获取用户列表
  addStaff: 'agent/bz/qnbar-agent/role/user/add', // 新增用户
  editStaff: 'agent/bz/qnbar-agent/role/user/edit', // 编辑用户
  delStaff: 'agent/bz/qnbar-agent/role/user/delete', // 删除用户
  modifyPass: 'agent/bz/qnbar-agent/role/user/password/edit', // 修改密码
  editStaffStatus: 'agent/bz/qnbar-agent/role/user/status/edit', // 编辑用户状态（冻结/解冻）
  getCachePermission: 'agent/bz/role-permission/role/cache/get', // 获取缓存权限

  // 平台跳转授权请求
  grantJumpPlatform: 'agent/bz/grant/platform-jump',

  // 合作商
  getdetail: 'agent/bz/qnbar-agent/get-base-info', // 获取自己详情
  getlist: 'agent/bz/mix-agent/get-list', // 商家列表
  getprovincelist: 'common/oss/region/get-province', // 省份列表
  getcitylist: 'common/oss/region/get-city', // 市区列表
  getAreasList: 'common/oss/region/get-areas',       // 区县列表
  Modifypassword: 'agent/bz/qnbar-agent/change-pwd', // 修改密码
  getdetailinfo: 'agent/bz/mix-agent/get-info', // 获取详情
  changestatus: 'agent/bz/mix-agent/change-status', // 冻结解冻
  resetpassword: 'agent/bz/mix-agent/reset-pwd', // 重置商家密码
  // 申请门店相关接口
  getRequestList: 'agent/store/checkStoreGet',  // 获取建店申请门店列表
  addCheckAgents: 'agent/store/addCheckAgents', // 提交门店申请
  editCheckAgents: 'agent/store/editCheckAgents', // 编辑审核门店
  getAgentByAsn: 'agent/store/checkAgentByAsn', // 获取门店详情
  deleteCloseAgent: 'agent/store/closeCheckAgent', // 撤销关闭提交门店申请
  getLogData: 'agent/store/logGetByAsn', // 查看操作记录
  // 序列号

  getimeilist: 'agent/bz/qnbar-agent/get-imei-list', // 获取序列号列表
  addimei: 'agent/bz/qnbar-agent/add-imei', // 添加序列号
  searchimei: 'agent/bz/qnbar-agent/find-imei', // 搜索imei
  delImei: 'agent/bz/qnbar-agent/del-imei', // 删除imei

  bindingStoreLists: 'agent/bz/qnbar-agent/get-agent-name', // 获取绑定序列号门店列表
  searchAgentStore: 'agent/bz/qnbar-agent/search-agent', // 搜索门店
  bandAgent: 'agent/bz/qnbar-agent/band-agent', // 绑定门店
  bandOffAgent: 'agent/bz/qnbar-agent/band-off-agent', // 解绑门店
  createMixDemo: 'agent/bz/qnbar-agent/create-mix-demo', // 创建演示门店
  getagent: 'bz-oss/oss/qnbar-agent/get-select-list', // 获取合作商

  // 门店广告有关
  getStorePoster: 'bz-oss/oss/commercial/poster/list/get', // 根据门店id获取海报
  updateStorePoster: 'bz-oss/oss/commercial/poster/update', // 根据门店ID更新官方海报
  deleteStorePoster: 'bz-oss/oss/commercial/poster/del', // 根据门店ID删除官方海报
  getStoreVideo: 'bz-oss/oss/commercial/animation/get-video', // 根据门店id获取开机动画视频
  updateStoreVideo: 'bz-oss/oss/commercial/animation/set-video', // 根据门店id设置开机动画视频
  getAnimationType: 'bz-oss/oss/commercial/animation-type/get', // 根据门店id获取开机动画类型
  updateAnimationType: 'bz-oss/oss/commercial/animation-type/set', // 根据门店id设置开机动画类型
  getAnimationImg: 'bz-oss/oss/commercial/animation/get-pic', // 根据门店id获取开机动画图片
  updateAnimationImg: 'bz-oss/oss/commercial/animation/set-pic', // 根据门店id设置开机动画图片

  getStoreList: 'agent/bz/qnbar-agent/get-name-id-list', // 获取合作商门店列表

  addDmeoStore: 'agent/bz/qnbar-agent/mix-agent/create', // 新增demo门店
  getSystemList: 'common/mix-agent/system/get-type', // 获取可用影视系统
  editstoreinfo: 'agent/bz/qnbar-agent/mix-agent/update', // 修改门店

  // 租赁设备
  getLeaseDeviceList: 'api/lease/get-device-list', // 获取租赁设备列表
  modifyDeviceLease: 'api/lease/modify-device-lease', // 修改租赁设备状态
  getAgentLeaseList: 'api/lease/get-agent-list', // 获取租赁设备门店列表
  getSnList: 'api/lease/get-sn-list', // 获取租赁设备信息
  getRentalEquipmentUseDetails: 'agent/psn/lease/use/info',   // 获取租赁设备使用详情
  GetDisconnectionInformation: 'agent/psn/lease/disconnected/get', // 获取设备断网信息
  SetDisconnectionStatus: 'agent/psn/lease/disconnected/set',     // 设置设备是否断网的使用
  BatchDeleteDeviceList: 'agent/bz/qnbar-agent/psn/batch/del',      // 批量删除设备
  BatchUnbindDeviceList: 'agent/bz/qnbar-agent/psn/batch/bind/off', // 批量解绑设备
  BatchChangeBindDeviceList: 'agent/bz/qnbar-agent/psn/batch/change', // 批量换绑设备
  // 门店组
  storeGroupTypeList: 'bz-oss/oss/store/type/get', // 获取门店组类型列表
  leaseExcelExport: 'agent/bz/lease/excel/export', // 导出租赁信息

  // 租赁管理2
  exportLeaseMoneyFlowForAgent: 'agent/leaseRecord/exportLeaseMoneyFlowForAgent', // 导出购买记录
  leaseMoneyFlowForAgent: 'agent/leaseRecord/leaseMoneyFlowForAgent', // 购买结算记录
  leaseStore: 'agent/bz/qnbar-agent/lease/store', // 租赁门店获取
  leaseStoreUpdate: 'agent/bz/qnbar-agent/lease/store/update', // 租赁门店编辑
  leaseKeysModels: 'agent/bz/qnbar-agent/lease/keys/models', // 获取可选型号
  leaseAllKeys: 'agent/bz/qnbar-agent/lease/all/keys', // 获取所有的key
  leaseModelsKeysUpdate: 'agent/bz/qnbar-agent/lease/models/keys/update', // 增加key型号
  leasePsnList: 'agent/bz/qnbar-agent/lease/psn/list', // 租赁设备检索
  getMoneyFlow: 'agent/leaseRecord/getMoneyFlow', // 结算明细
  exportMoneyFlow: 'agent/leaseRecord/exportMoneyFlow', // 导出结算明细
  getAgentSettlementRecord: 'agent/leaseRecord/getAgentSettlementRecord', // 结算记录
  exportAgentSettlementRecord: 'agent/leaseRecord/exportAgentSettlementRecord', // 导出结算记录
  getStoreNameList: 'agent/bz/mix-agent/get-list', // 商家列表
  leaseKeysDetail: 'agent/bz/qnbar-agent/lease/keys/detail', // 密钥详情
  leasePasAdd: 'agent/bz/qnbar-agent/lease/psn/add', // 租赁设备增加
  leasePsnDel: 'agent/bz/qnbar-agent/lease/psn/del', // 租赁设备解除
  leaseKeysAlert: 'agent/bz/qnbar-agent/lease/keys/alert', // 密钥剩余情况
  leaseKeysDetailInfo: 'agent/bz/qnbar-agent/lease/keys/detail/info', // 密钥详情info
  exportStoreLease: 'agent/bz/qnbar-agent/lease/exportStoreLease', // 导出租赁门店
  exportLeaseDetail: 'agent/bz/qnbar-agent/lease/exportLeaseDetail', // 导出密钥详情
  exportDetailInfo: 'agent/bz/qnbar-agent/lease/exportDetailInfo', // 导出密钥详情info

  // 租赁管理3
  distributeKeys: 'agent/bz/qnbar-agent/lease/keys/distribute', // 分发密匙
  getDistributeLogs: 'agent/bz/qnbar-agent/lease/distribute/logs/get', // 获取分发列表
  exportDistributeKeys: 'agent/bz/qnbar-agent/lease/exportDistributeKeys',

  // 共享文件
  getShareFolder: 'agent/folder/folderGet', // 获取共享文件夹
  getShareFiles: 'agent/folder/fileGet',     // 获取共享文件

  // 维修相关
  addRepair: 'warehouse/agent/repair/add',                      // 新增维修单
  getRepair: 'warehouse/agent/repair/get',                      // 查询维修单
  editDetailsRepair: 'warehouse/oss/repair/edit',               // 编辑维修单信息
  getWarehouseGoods: 'warehouse/goods/list',                    // 获取商品列表
  payOrderRepair: 'warehouse/agent/repair/order/pay',           // 下单支付
  editCheckStatusWarehouse: 'warehouse/oss/check/status/edit',  // 更新维修单状态接口
  queryActivationTime: 'warehouse/agent/psn/check',             // 查询激活时间
  getFileWarehouse: 'warehouse/agent/file/get',                 // 附件查询
  addFileWarehouse: 'warehouse/agent/file/add',                 // 附件新增
  deleteFileWarehouse: 'warehouse/agent/file/del',              // 附件删除
  getLogsRepair: 'warehouse/agent/repair/logs/get',             // 日志查询
  editPriceRepair: 'warehouse/agent/repair/price/edit',         // 批量改价
  editStatusPayRepair: 'warehouse/agent/repair/pay/status/edit', // 结算审核
  getOsnOrderRepair: 'warehouse/agent/repair/order/osn/get',    // 订单查询
  getDetailsRepair: 'warehouse/agent/repair/details/get',       // 查询维修单详情

  // psn列表批量操作
  agentPsnBatch: 'agent/bz/qnbar-agent/psn/batch',                  // 批量操作投影仪设备号

  // 电影管理/服务器管理
  agentMachineGet: 'agent/machine/get',                             // 获取服务器数据
  agentMachineSerStatusRefresh: 'agent/machine/svr/status/refresh',    // 获取服务器在线状态,储存状态
  agentSourceUpdateQueue: 'agent/source/updateQueue',                  // 下载列表  /   电影管理

  // 电影管理/电影黑名单
  agentGetMovieBlack: 'agent/film-black/film/list/get',                // 获取电影黑名单数据

  // 更新管理/通用软件
  agentAppThirdAppGet: 'agent/app/thirdApp/get',                                  // 获取软件列表
  agentAppThirdAppGetBindStore: 'agent/app/thirdApp/getBindStore',                // 获取绑定门店
  agentAppThirdAppOpBindStore: 'agent/app/thirdApp/opBindStore',               // 操作软件门店关联
  agentMixagentNameidList: 'agent/mix-agent/name-id/list',                                              // 获取所有门店

  // 电影白名单
  getWhiteFilmList: 'agent/film/white/get',               // 获取电影白名单列表
  getWhiteStoreStatus: 'agent/film/white/status/get',     // 获取白名单状态（门店）
  exportWhiteFilm: 'agent/film/white/export',             // 导出电影白名单列表

  // 回访系统相关
  QueryisteturnVisitServices: 'agent/return/visit/record/list',     // 查询回访服务列表
  ExportReturnVisitRecords: 'agent/return/visit/record/export',    // 导出回访记录
  AddReturnVisitRecord: 'agent/return/visit/record/add',            // 新增回访记录
  EditReturnVisitRecord: 'agent/return/visit/record/edit',          // 编辑回访服务
  DeleteReturnVisitRecord: 'agent/return/visit/record/delete',       // 删除回访记录
  FindNamePartnerStore: 'agent/agent/dynamic/query/list',             // 查找合作商店名

  // 青柠电影OTT设备
  agentOttDeviceList: 'agent/ott/device/list', // 获取电影设备列表
  agentOttDeviceInfo: '/agent/ott/device/info', // 电影设备日志详情
  agentOttDeviceExport: 'agent/ott/device/export', // 添加导出接口

  // 借机服务相关
  GetBorrowMachineList: 'agent/borrow_record/partner/list',                 // 获取借机列表数据
  AddBorrowMachineApplication: 'agent/borrow_record/partner/create_order',  // 新增借机申请
  GetOrderQRCode: 'agent/borrow_record/partner/get_qr_code',                // 获取订单支付二维码
  EditBorrowMachineOrder: 'agent/borrow_record/partner/edit',               // 编辑订单信息
  GetDeviceInformation: 'agent/borrow_record/partner/get_machine',          // 获取设备信息
  GetMailingAddressAndLoanMachineAgreement: 'agent/borrow_conf/detail',    // 获取借机协议或邮寄地址
  GetOrderStatus: 'agent/borrow_record/partner/get_pay_status',             // 获取订单状态
  CancelBorrowMachineOrder: 'agent/borrow_record/partner/revoke_order',     // 撤销借机订单
  GetBorrowOrderDetails: 'agent/borrow_record/partner/detail',              // 获取借机单详情
  EditReturnedEquipment: 'agent/return_record/edit',                        // 编辑归还设备
  GetEquipmentCanBrented: 'agent/borrow_record/partner/get_psn',            // 根据hg_sn获取可租借的设备psn
  BatchReturnEquipment: 'agent/return_record/batch_add',                    // 批量归还设备
  ExportBorrowMachineList: 'agent/borrow_record/partner/export',            // 导出合作商借机列表
  GetExpiredBorrowMachineOrderData: 'agent/borrow_record/partner/get_su_day',       // 获取快过期借机单的数据

  // 内容审核
  agentInterfaceAuditList: 'agent/interface/audit/list',                    // 合作商查询审核记录列表
  bzOssInterfaceAuditWhitelistCheck: 'bz-oss/interface/audit/whitelist/check',  // OSS-根据GUID查询白名单状态
  interfaceAuditItems: '/bz-mix/interface/audit/items',                    // BZMIX-查询指定门店内容类型待审核的列表

  // 申请建店
  ossOssHideLogItem: 'bz-oss/oss/hide/log/item',                            // 申请建店 门店组筛选
  getFastStoreList: 'bz-oss/oss/mix-agent/name-id/list',                    // 查询门店列表
  ossOttDeviceExport: 'bz-oss/ott/device/export',                           // 导出设备

  // 芒果TV会员
  getMangoMemberList: 'bz-oss/film-center/mg_member/list',                  // 获取芒果会员列表
  exportmangoMemberList: 'bz-oss/film-center/mg_member/member_export',      // 导出芒果会员列表

  // 售后换货
  exAgentOrderList: 'ex/agent/order/list',                                  // 获取换货列表
  exAgentOrderExport: 'ex/agent/order/export',                              // 换货列表导出
  exAgentOrderInfo: 'ex/agent/order/info',                                  // 查询换货详情

  // 华为云上传
  commonOssUpload: 'common/oss/upload',       						   // 拉取上传配置
  uploadWSCommonOss: 'common/ws/upload',      						   // 拉取上传配置(网宿)
  HuaWeiCommonOssUpload: 'common/hwobs/upload',						// 拉取华为云上传配置
  HuaWeiSectionUpload: 'common/hwobspart/upload',					    // 拉取华为云分段上传配置
  HuaWeiMergeSection: 'common/hwobspart/merge',						// 华为云分段上传后合并端
  HuaWeiCancelUpload: 'common/hwobspart/cancel',					    // 取消华为云上传
  HuaweiAndWsUpload: 'common/upload',								    // 获取上传配置（根据后端的返回的结果，决定是华为还是网宿）

  // 清除缓存
  commonClearPsn: '/common/clear/psn',                                       // 清除设备缓存
  commonClearStore: '/common/clear/store',                                   // 清除门店缓存
  commonClearAgent: '/common/clear/agent',                                   // 清除合作商缓存
  commonClearAppWhite: '/common/clear/app_white',
  getAuditStore: 'agent/store/storeStatusCount',                   		   // 获取待审核门店数据

  // 售后维修
  expairManageExportListForAgent: 'repair-manage/export-list-for-agent',       // 维修记录导出
  repairManageAgentList: 'repair-manage/agent/list',                           // 经销商列表查询
  repairManageSearchList: 'repair-manage/search-list',                         // 获取维修工单列表（带部件信息）
  repairManageSearchSendList: 'repair-manage/search-send-list',                // 获取收件人列表
  editsystemSettings: 'repair-manage/set-edit',							     // 系统设置编辑
  systemSettingsDetails: 'repair-manage/set-info',					         // 系统设置详情
  getPartsList: 'repair-manage/parts-list',								     // 获取部件列表
  getPartDetails: 'repair-manage/parts-info',								     // 获取部件详情
  repairManagePartsUseList: 'repair-manage/parts-use-list',	                 // 部件列表使用详情
  repairManagePartsUseExportList: 'repair-manage/parts-use-export-list',	     // 部件列表使用详情导出
  editPartInformation: 'repair-manage/parts-edit',					         // 编辑部件信息
  delPart: 'repair-manage/parts-del',										     // 删除部件
  getPartsAll: 'repair-manage/parts-all',                                      // 获取全部部件
  importFaultDetection: 'repair-manage/check-wx-data',						 // 导入维修检测
  saveFaultDetection: 'repair-manage/batch-save-wx-data',					     // 保存维修检测
  importMaintenanceInspection: 'repair-manage/confirm-wx-data',		         // 导入维修质检
  saveMaintenanceInspection: 'repair-manage/batch-save-confirm-data',		     // 保存维修质检
  repairManageBatchXxjhCheck: 'repair-manage/batch-xxjh-check',		         // 批量线下寄回校验
  repairManageBatchXxjhSave: 'repair-manage/batch-xxjh-save',		             // 批量线下寄回保存
  getMaintenanceOfSingleDetails: 'repair-manage/info',						 // 维修单详情
  repairManageEditTj: 'repair-manage/edit-tj',                                 // 维修单-编辑-提交申请状态
  repairManageEditSh: 'repair-manage/edit-sh',                                 // 维修单-编辑-确认收货状态
  repairManageEditShRemark: 'repair-manage/edit-sh-remark',                    // 维修单-编辑-编辑收货说明
  repairManageEditJc: 'repair-manage/edit-jc',                                 // 维修单-编辑-确认故障检测
  repairManageEditJcRemark: 'repair-manage/edit-jc-remark',                    // 维修单-编辑-编辑故障说明
  repairManageEditWx: 'repair-manage/edit-wx',                                 // 维修单-编辑-确认维修质检
  repairManageEditWxRemark: 'repair-manage/edit-wx-remark',                    // 维修单-编辑-编辑维修说明
  repairManageEditJh: 'repair-manage/edit-jh',                                 // 维修单-编辑-确认产品寄回
  repairManageEditJhRemark: 'repair-manage/edit-jh-remark',                    // 维修单-编辑-编辑产品寄回
  repairManageCancelExpress: 'repair-manage/cancel-express',                   // 维修单-编辑-取消上门取件
  repairManageEditWc: 'repair-manage/edit-wc',                                 // 维修单-编辑-确认完成
  repairManageCheckModel: 'repair-manage/check-model',                         // 维修单-新增-校验
  repairManageCreateOrder: 'repair-manage/create-order',                       // 维修单-新增-保存
  repairManageRevokeOrder: 'repair-manage/revoke-order',                       // 维修单-新增-撤销
  repairManageRevokeOrderRemark: 'repair-manage/revoke-order-remark',          // 维修单-编辑-撤销
  repairManageSettleOrder: 'repair-manage/settle-order',                       // 维维修单-结算-线下
  repairManageGetQrCode: 'repair-manage/get-qr-code',                          // 维修单-结算-线上
  repairManageGetOrderPayType: 'repair-manage/get-order-pay-type',             // 维修单-结算-检查支付状态
  repairManageExportHzd: 'repair-manage/export-hzd',                           // 维修单-下载回执单,
  repairManageBatchSmqjCheck: 'repair-manage/batch-smqj-check',                // 批量上门取件校验,
  repairManageBatchDchzdCheck: 'repair-manage/batch-dchzd-check',              // 批量导出回执单校验,
  repairManageBatchGetPersonInfo: 'repair-manage/batch-get-person-info',       // 批量获取收件人,
  repairManageCashList: 'repair-manage/cash-list',                             // 维修流水列表,
  repairManageCashExportList: 'repair-manage/cash-export-list',                // 维修流水列表导出
  repairManageExpressInfo: 'repair-manage/express-info',                       // 物流查询
  repairManageQuotedPrice: 'repair-manage/quoted-price',                       // 报价

  // 影咖合作商相关接口
  umStoreRevenueReport: 'agent/um/store/revenue/report',                        // 获取门店营收订单
  umStoreRevenueExport: 'agent/um/store/revenue/export',                        // 导出门店营收订单
  umStorePayReport: 'agent/um/store/pay/report',                                // 获取门店支付订单
  umStorePayExport: 'agent/um/store/pay/export',                                // 导出门店支付订单
  umStoreOrderReport: 'agent/um/store/order/report',                            // 获取门店订单
  umStoreOrderExport: 'agent/um/store/order/export',                            // 导出门店订单
  umRevenueChart: 'agent/um/revenue/chart',                                     // 获取营收占比
  umPayChart: 'agent/um/pay/chart',                                             // 获取营收占支付比
  umStoreRevenueChart: 'agent/um/store/revenue/top/chart',                      // 获取营收占支付比top10
  umTotalRevenueChart: 'agent/um/total/revenue/chart',                          // 获取总营收趋势
  umPersonRevenueChart: 'agent/um/person/revenue/chart',                        // 获取入场人数趋势
  umDurationRevenueChart: 'agent/um/duration/revenue/chart',                    // 获取时段营收占比
  umRoomRevenueTopChart: 'agent/um/room/revenue/top/chart',                     // 获取房间收银top10
  umGoodsRevenueTopChart: 'agent/um/goods/revenue/top/chart',                   // 获取商品零售top10
  umRechargeRevenueTopChart: 'agent/um/recharge/revenue/top/chart',             // 获取会员充值top10
  ossMixagentGetList: 'bz-oss/oss/mix-agent/get-list',                          // 获取门店
  getUmClientRoomlist: 'agent/um/client/room/play/get',                         // 获取播放记录
  exprotUmClientRoomlist: 'agent/um/client/room/play/export',                   // 导出播放记录
  umFreezingEquipment: 'agent/um/pro-imei/freeze-imei',                         // 冻结设备
  umBathFreezingEquipment: 'agent/um/pro-imei/batch/frozen',                    // 批量冻结设备
  umUnfreezeEquipment: 'agent/um/pro-imei/unfreeze-imei',                       // 解冻设备

  // 温度监测
  tempStatPsnList: 'agent/temp/stat/psn-list',                                     // 高温设备列表
  tempStatPsnTempDetail: 'agent/temp/stat/psn-temp-detail',                        // 高温详情
  tempStatPsnTempLog: 'agent/temp/stat/psn-temp-log',                              // 高温日志列表
  tempStatDealHotPsn: 'agent/hzs-temp/stat/deal-hot-psn',                          // 处理高温设备
  tempStatDealHotPsnList: 'agent/temp/stat/deal-hot-psn-list',                     // 处理日志列表
  tempStatPsnModelList: 'agent/temp/stat/psn-model-list',                          // 监测设备列表
  tempStatEditPsnModel: 'agent/temp/stat/edit-psn-model',                          // 编辑监测设备
  getModelList: 'firmware/getModelList',                                           // 获取纯固件型号列表
  tempStatMonthStatistics: 'temp/stat/month-statistics',                           // 全部设备高温统计
  tempStatPsnListexport: 'agent/temp/stat/psn-list-export',                        // 高温设备列表导出
  tempStatPsnTempLogexport: 'agent/temp/stat/psn-temp-log-export',                 // 高温日志列表导出
  tempStatDealHotPsnListexport: 'agent/temp/stat/deal-hot-psn-list-export',        // 处理日志列表导出

  // 软件商城
  agentThirdAppNewGet: 'software/agent/thirdApp/new/get',                       // 获取软件
  agentThirdAppGetBindStore: 'software/agent/thirdApp/getBindStore',            // 获取详情
  agentThirdAppOpBindStore: 'software/agent/thirdApp/opBindStore',              // （推送/取消推送）软件
  thirdAppCountGet: 'software/thirdApp/count/get',                              // 获取门店软件下载次数
  umBathUnfreezeEquipment: 'agent/um/pro-imei/batch/relieve/frozen',            // 批量解冻设备

  // 租赁三
  agentLeaseXcList: 'agent/lease/xc/list',                                      // 查询租赁3列表
  agentLeaseXcExport: 'agent/lease/xc/export',                                  // 导出租赁3列表
  agentLeaseXcAdd: 'agent/lease/xc/add',                                        // 新增租赁3
  agentLeaseXcEdit: 'agent/lease/xc/edit',                                      // 编辑租赁3
  agentLeaseXcStatusEdit: 'agent/lease/xc/status/edit',                         // 编辑租赁3开通状态
  agentLeaseXcRecordReport: 'agent/lease/xc/record/report',                     // 查询租赁3授权统计
  agentLeaseXcRecordReportExport: 'agent/lease/xc/record/report/export',        // 导出租赁3授权统计
  agentLeaseXcDetailReport: 'agent/lease/xc/detail/report',                     // 查询租赁3授权明细
  agentleaseXcDetailReportExport: 'agent/lease/xc/detail/report/export',        // 导出租赁3授权明细

  // 租赁三
  agentLeaseXcList: 'agent/lease/xc/list',                                      // 查询租赁3列表
  agentLeaseXcExport: 'agent/lease/xc/export',                                  // 导出租赁3列表
  agentLeaseXcAdd: 'agent/lease/xc/add',                                        // 新增租赁3
  agentLeaseXcEdit: 'agent/lease/xc/edit',                                      // 编辑租赁3
  agentLeaseXcStatusEdit: 'agent/lease/xc/status/edit',                         // 编辑租赁3开通状态
  agentLeaseXcRecordReport: 'agent/lease/xc/record/report',                     // 查询租赁3授权统计
  agentLeaseXcRecordReportExport: 'agent/lease/xc/record/report/export',        // 导出租赁3授权统计
  agentLeaseXcDetailReport: 'agent/lease/xc/detail/report',                     // 查询租赁3授权明细
  agentleaseXcDetailReportExport: 'agent/lease/xc/detail/report/export',        // 导出租赁3授权明细

  // ott通用版
  agentBzMixAgentApplyAuth: 'agent/bz/mix-agent/apply_auth',                    // 申请授权书
  agentBzMixAgentAuthSearchStore: 'agent/bz/mix-agent/auth_search_store',       // 搜索门店
  agentBzMixAgentApplyList: 'agent/bz/mix-agent/apply_list',                    // 授权书列表
  agentBzMixAgentMacAdd: 'agent/bz/mix-agent/mac/add',                          // 会员新增
  agentBzMixAgentMacGet: 'agent/bz/mix-agent/mac/get',                          // 会员获取
  agentBzMixAgentMacSearch: 'agent/bz/mix-agent/mac/search',                    // 检索设备是否已开通
  agentRefillLast: 'bz-oss/card/agent/refill_last',                             // 获取合作商最新一条充值记录
  agentBzMixAgentMacTimeAdd: 'agent/bz/mix-agent/mac/time/add',                 // 续会员
  agentBzMixAgentMacSearchStore: 'agent/bz/mix-agent/mac/search/store',         // 检索门店设备
  agentMacPsnNumberGet: 'agent/bz/mix-agent/mac/psn/number/get',                // 获取会员分类数量

  // 青柠会员合作商平台
  agentOttMemberList: 'agent/ott/member/list',                                  // 青柠会员-列表
  agentOttMemberExpire: 'agent/ott/member/expire',                              // 青柠会员-续会员
  agentOttMemberReplace: 'agent/ott/member/replace',                            // 青柠会员-替换
  agentOttMemberNum: 'agent/ott/member/num',                                    // 青柠会员-获取各状态会员数量
  agentOttMemberExport: 'agent/ott/member/export',                              // 青柠会员-导出会员
  agentOttMemberAdd: 'agent/ott/member/add',                                    // 青柠会员-开通设备
  ottMemberRecognition: 'bz-oss/ott/member/recognition',                        // ott识别设备
  filmCenterMgMemberRecognition: 'bz-oss/film-center/mg_member/recognition',    // 芒果识别设备
  agentMgMemberList: 'agent/mg/member/list',                                    // 芒果TV-列表
  agentMgMemberExport: 'agent/mg/member/export',                                // 芒果TV-导出会员
  agentMgMemberAdd: 'agent/mg/member/add',                                      // 芒果TV-开通设备
  agentMgMemberExpire: 'agent/mg/member/expire',                                // 芒果TV-续会员
  agentMgMemberNum: 'agent/mg/member/num',                                      // 芒果TV-获取各状态会员数量
  agentOttWorkList: 'agent/ott/work/list',                                      // 工单-工单列表
  agentOttWorkExport: 'agent/ott/work/export',                                  // 工单-工单导出
  authAgentNum: 'bz-oss/auth/agent/num',                                        // 获取授权书各状态数量
  agentOttMemberDel: 'agent/ott/member/del',                                    // 青柠会员-删除
  agentMgMemberDel: 'agent/mg/member/del',                                      // 芒果TV-删除
  agentBzMixAgentMacPsnExport: 'agent/bz/mix-agent/mac/psn/export',             // 影视会员-导出
  memberFilmStoreSearch: 'bz-oss/ott/member/film_store/search',                 // 影视会员-门店列表
  appAppVersionList: 'app/appVersionList',
  agentOttMemberBlackList: 'agent/ott/member/blacklist/fetch',                           // 查询合作商赠送会员黑名单状态

  //云游戏
  agentGameOrderList: 'agent/game/order/list',                                  //查询云游戏订单
  agentGameOrderExport: 'agent/game/order/export',                              //导出云游戏订单
  //软件卸载
  softwareAgentThirdAppUninstall: "software/agent/thirdApp/uninstall",                              //卸载软件
  softwareAgentThirdAppCancleUninstall: "software/agent/thirdApp/cancel_uninstall",                    //取消卸载
  softwareAgentThirdAppAll_uninstall: "software/agent/thirdApp/all_uninstall",  //全部卸载
  softwareAgentThirdAppAll_cancel: "software/agent/thirdApp/all_cancel",        //全部取消     

  //清除缓存
  commonClearrojectorCache: "common/clear/projector/cache",                 //清除缓存 

}



// WEBPACK FOOTER //
// ./src/svrapi.js